import React from "react";
import { Switch, Route, Redirect, useParams } from "react-router-dom";

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import AuditShow from 'views/Audit/Show.js';
import AnswerActionEdit from 'views/AnswerAction/Auditee/Edit.js';
import AuditeeProofForm from 'views/Form/Proof/Auditee.js';
import AuditeeEvaluationForm from 'views/Form/Evaluation/Auditee.js';
// dinamically create dashboard routes
import auditeeRoutes from "routes/auditee.js";

import image1 from "assets/img/full-screen-image-1.jpg";
import image2 from "assets/img/full-screen-image-2.jpg";
import image3 from "assets/img/full-screen-image-3.jpg";
import image4 from "assets/img/full-screen-image-4.jpg";

function AuditeeLayout() {

  const {employeeId} = useParams();

  const [sidebarImage, setSidebarImage] = React.useState(image3);
  const [sidebarBackground, setSidebarBackground] = React.useState("azure");

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {

      if (prop.collapse) {
        return getRoutes(prop.views);
      }

      return (
        <Route
          exact
          path={`${prop.layout}/:employeeId${prop.path}`}
          key={key}
          component={prop.component}
        />
      );
    });
  };

  return (
    <div className="wrapper">
      <Sidebar
        layout={`auditee`}
        routes={auditeeRoutes}
        image={sidebarImage}
        background={sidebarBackground}
      />
      <div className="main-panel">
        <AdminNavbar />
        <div className="content">
          <Switch>
            <Route exact path="/auditee/:employeeId/proofs/:formId" component={AuditeeProofForm} />
            <Route exact path="/auditee/:employeeId/evaluations/:formId" component={AuditeeEvaluationForm}/>
            <Route exact path="/auditee/:employeeId/actions/:actionId/edit" component={AnswerActionEdit}/>
            {getRoutes(auditeeRoutes)}
            <Route path="/auditee/:employeeId/audits/:scheduleId" component={AuditShow} />
            <Redirect to="/auth/404" />
          </Switch>
        </div>
        <AdminFooter />
        <div
          className="close-layer"
          onClick={() =>
            document.documentElement.classList.toggle("nav-open")
          }
        />
      </div>
    </div>
  );
}

export default AuditeeLayout;
